var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutfordelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_1092)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8065 0H5.19355C2.32523 0 0 2.32523 0 5.19355V40.8065C0 43.6748 2.32523 46 5.19355 46H40.8065C43.6748 46 46 43.6748 46 40.8065V5.19355C46 2.32523 43.6748 0 40.8065 0Z",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1035_1092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9107 9.64502H9.64453V36.9111H36.9107V9.64502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1035_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0823 15.6484C31.4462 16.1969 32.3506 17.5792 33.4843 19.4819H29.0823V15.6484ZM15.267 19.6416C15.7299 19.6416 16.0658 19.865 16.0658 20.3872C16.0658 20.8276 15.7095 21.1847 15.2693 21.186H10.4434C10.0021 21.186 9.64453 21.5438 9.64453 21.9848C9.64453 22.426 10.0021 22.7836 10.4434 22.7836H17.6327C18.078 22.7836 18.4346 23.1409 18.4346 23.5825C18.4346 24.0236 18.077 24.3812 17.6358 24.3812H10.4434C10.0021 24.3812 9.64453 24.7388 9.64453 25.1801C9.64453 25.6213 10.0021 25.9788 10.4434 25.9788H12.2007V28.3753C12.2007 28.8165 12.5583 29.1741 12.9996 29.1741H14.6053C14.8915 30.5841 16.1374 31.6238 17.606 31.6238C19.0747 31.6238 20.3205 30.5841 20.6068 29.1741H28.7176C29.0039 30.5841 30.2497 31.6238 31.7184 31.6238C33.187 31.6238 34.4329 30.5841 34.7191 29.1741H36.1118C36.553 29.1741 36.9107 28.8165 36.9107 28.3753V23.5825C36.9107 21.2386 34.4385 21.083 34.4362 21.0795H28.2835C27.8423 21.0795 27.4847 20.7219 27.4847 20.2807V15.4878H12.9996C12.5583 15.4878 12.2007 15.8454 12.2007 16.2866V18.044H11.2421C10.8009 18.044 10.4434 18.4016 10.4434 18.8428C10.4434 19.284 10.8009 19.6416 11.2421 19.6416H15.267ZM32.7539 27.5261C33.3258 28.098 33.3258 29.0256 32.7539 29.5974C31.834 30.5173 30.2539 29.8629 30.2539 28.5617C30.2539 27.2607 31.834 26.6062 32.7539 27.5261ZM18.6415 27.5261C19.2134 28.098 19.2134 29.0256 18.6415 29.5974C17.7217 30.5173 16.1415 29.8629 16.1415 28.5617C16.1415 27.2607 17.7217 26.6062 18.6415 27.5261Z",
    fill: "#7E807E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_1092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfordelivery);
export default __webpack_public_path__ + "static/media/outfordelivery.444c1ba72d3a424b4ad5c20c10ebc355.svg";
export { ForwardRef as ReactComponent };